import React from "react";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";
import { NumericFormat } from "react-number-format";

const Capnhatcoso = React.memo(function Capnhatcoso(props) {
  const { id } = props;
  const [ten, setTen] = React.useState("");
  const [hangxe, setHangxe] = React.useState("");
  const [luuluongdaotao, setLuuluongdaotao] = React.useState("");
  const [diachi, setDiachi] = React.useState("");
  const [thutruongdonvi, setThutruongdonvi] = React.useState("");
  const [soluonggiaovien, setSoluonggiaovien] = React.useState(0);
  const [soluongxetaplai, setSoluongxetaplai] = React.useState(0);
  const [dienthoai, setDienthoai] = React.useState("");
  const [coquanquanly, setCoquanquanly] = React.useState("");
  const [diadiemdaotao, setDiadiemdaotao] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getthongtin = () => {
    var url =
      Config.backend +
      "/api/CoSoGTVT/getcosodaotaotheoid?id=" +
      id +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setTen(data[0].ten);
        setHangxe(data[0].hangxe);
        setLuuluongdaotao(data[0].luuluongdaotao);
        setDiachi(data[0].diachi);
        setThutruongdonvi(data[0].thutruongdonvi);
        setSoluonggiaovien(data[0].soluonggiaovien);
        setSoluongxetaplai(data[0].soluongxetaplai);
        setDienthoai(data[0].dienthoai);
        setCoquanquanly(data[0].coquanquanly);
        setDiadiemdaotao(data[0].diadiemdaotao);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const capnhat = () => {
    var url = Config.backend + "/api/CoSoGTVT/capnhatcosodaotao";
    fetch(url, {
      method: "PUT",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        id: id,
        ten: ten,
        hangxe: hangxe,
        luuluongdaotao: luuluongdaotao,
        diachi: diachi,
        thutruongdonvi: thutruongdonvi,
        soluonggiaovien: soluonggiaovien,
        soluongxetaplai: soluongxetaplai,
        dienthoai: dienthoai,
        coquanquanly: coquanquanly,
        diadiemdaotao: diadiemdaotao,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          showNotification();
        } else showNotification1();
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  React.useEffect(() => {
    getthongtin();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 8 }}>
              <TextField
                label="Tên cơ sở đào tạo"
                variant="outlined"
                size="small"
                value={ten}
                onChange={(event) => {
                  setTen(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 8 }}>
              <TextField
                label="Số điện thoại"
                variant="outlined"
                size="small"
                value={dienthoai}
                onChange={(event) => {
                  setDienthoai(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 8 }}>
              <TextField
                label="Địa chỉ"
                variant="outlined"
                size="small"
                value={diachi}
                onChange={(event) => {
                  setDiachi(event.target.value);
                }}
                multiline
                rows={3}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 8 }}>
              <TextField
                label="Hạng xe đào tạo"
                variant="outlined"
                size="small"
                value={hangxe}
                onChange={(event) => {
                  setHangxe(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 8 }}>
              <TextField
                label="Lưu lượng đào tạo"
                variant="outlined"
                size="small"
                value={luuluongdaotao}
                onChange={(event) => {
                  setLuuluongdaotao(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 8 }}>
              <TextField
                label="Thủ trưởng đơn vị"
                variant="outlined"
                size="small"
                value={thutruongdonvi}
                onChange={(event) => {
                  setThutruongdonvi(event.target.value);
                }}
                multiline
                rows={3}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 8 }}>
              <NumericFormat
                label="Số lượng giáo viên"
                variant="outlined"
                size="small"
                value={soluonggiaovien}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSoluonggiaovien(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 8 }}>
              <NumericFormat
                label="Số lượng xe tập lái"
                variant="outlined"
                size="small"
                value={soluongxetaplai}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSoluongxetaplai(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 8 }}>
              <TextField
                label="Địa điểm đào tạo"
                variant="outlined"
                size="small"
                value={diadiemdaotao}
                onChange={(event) => {
                  setDiadiemdaotao(event.target.value);
                }}
                multiline
                rows={3}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 8 }}>
              <TextField
                label="Cơ quan quản lý"
                variant="outlined"
                size="small"
                value={coquanquanly}
                onChange={(event) => {
                  setCoquanquanly(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "30px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={capnhat}
        >
          Cập nhật
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Cập nhật thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình cập nhật"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

Capnhatcoso.propTypes = {
  id: PropTypes.number,
};
export default Capnhatcoso;
